import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import type { LoadFlowScenarioInputs } from '../../../..';
import { Voltage } from '../../../../domain/Voltage';
import {
  findGridElementLabel,
  findGridElementTitle
} from '../../findGridElementLabel';
import type { ExternalNetworkInjectionLoadFlowDetails } from '../gridElementLoadFlowDetails.types';
import { Features } from '../../../../createGridElementCalculationSetExecutionDetails';

export function createExternalNetworkInjectionLoadFlowDetails(
  features: Features,
  inputs: LoadFlowScenarioInputs
): ExternalNetworkInjectionLoadFlowDetails[] {
  return inputs.startValues.map(startValue => ({
    id: startValue.connectedToId,
    objectType: 'ExternalNetworkInjection',
    label: findGridElementLabel(features, startValue.connectedToId),
    title: findGridElementTitle(features, startValue.connectedToId),
    inputs: { voltage: new Voltage(startValue.voltage) }
  }));
}
